module.exports = __webpack_public_path__ + "img/7.321ee6fc.png";